import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import BaseComponent from './BaseComponent';

const propTypes = {
  // This marks that this is a controlled component, whose source of truth is at outside.
  isVisible: PropTypes.bool.isRequired,
  onVisibleChange: PropTypes.func,
};

@autobind
class BaseDialog extends BaseComponent {
  constructor(props) {
    super(props);
  }

  /* PUBLIC */
  dismiss() {
    this.onModalHide();
  }

  onOkClick() {
    this.dismiss();
  }

  onModalHide() {
    if (this.props.onVisibleChange) {
      this.props.onVisibleChange(false);
    }
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
BaseDialog.propTypes = propTypes;

export default BaseDialog;
